import { UserRoles, UserRoleLevels } from '../components/roster/types';

/**
 * Check if role is equal or greater than the required role.
 * @param requiredRole
 * @param userRole
 */
export const checkPermission = (requiredRole: UserRoles, userRole: UserRoles) => UserRoleLevels[userRole] >= UserRoleLevels[requiredRole];
